import { useQuery } from "@tanstack/react-query";
import { getInstalledAppVersionsAction, IGetInstalledAppVersionsQueryParams } from "../actions/getInstalledAppVersions.action";

export const INSTALLED_APP_VERSIONS_QUERY_KEY = "superadmin-installed-app-versions";

export const useInstalledAppVersionsQuery = (params?: IGetInstalledAppVersionsQueryParams) => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: [INSTALLED_APP_VERSIONS_QUERY_KEY, params],
    queryFn: () => getInstalledAppVersionsAction(params),
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
};
